import TemplateView from '../../../TemplateView'
import DescriptionBlock from './DescriptionBlock'
import messageResource from '../../../messageResource'

export default class SettingsInfoContent extends TemplateView {
    constructor({
        extraClass = '',
        enabledTextKey,
        enabledImageTopDescKey = '',
        enabledImageBottomDescKey = '',
        disabledTextKey,
        disabledImageTopDescKey = '',
        disabledImageBottomDescKey = '',
    }) {
        super()

        this.params = {
            extraClass,
            enabledTextKey,
            enabledImageTopDescKey,
            enabledImageBottomDescKey,

            disabledTextKey,
            disabledImageTopDescKey,
            disabledImageBottomDescKey,
        }
    }

    templateHtml() {
        return '<div class="settingsInfo <%=extraClass%>">' +
               '</div>'
    }

    afterRender() {
        new DescriptionBlock({
            extraClass: 'enabled',
            name: messageResource.getMessage('dar_settings.enabled_block_name'),
            text: messageResource.getMessage(this.params.enabledTextKey),
            imageTopDescription: this.params.enabledImageTopDescKey ? messageResource.getMessage(this.params.enabledImageTopDescKey) : '',
            imageBottomDescription: this.params.enabledImageBottomDescKey ? messageResource.getMessage(this.params.enabledImageBottomDescKey) : '',
        }).init(this.$el)
        new DescriptionBlock({
            extraClass: 'disabled',
            name: messageResource.getMessage('dar_settings.disabled_block_name'),
            text: messageResource.getMessage(this.params.disabledTextKey),
            imageTopDescription: this.params.disabledImageTopDescKey ? messageResource.getMessage(this.params.disabledImageTopDescKey) : '',
            imageBottomDescription: this.params.disabledImageBottomDescKey ? messageResource.getMessage(this.params.disabledImageBottomDescKey) : '',
        }).init(this.$el)

    }

    templateModel() {
        return {
            extraClass: this.params.extraClass,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/darSettings/components/SettingsInfoContent.js